import { Listing, Property } from '../types';

/**
 * Convert a Listing object to a Property object for financial dashboard use
 */
export const convertListingToProperty = (listing: Listing): Property => {
  return {
    id: listing.listingId,
    name: listing.title,
    address: `${listing.address.street}, ${listing.address.city}, ${listing.address.state}`,
    status: listing.status === 'published' ? 'active' : 'inactive',
    currency: listing.pricing.currency
  };
};

/**
 * Convert multiple Listing objects to Property objects
 */
export const convertListingsToProperties = (listings: Listing[]): Property[] => {
  return listings.map(convertListingToProperty);
};

/**
 * Filter active properties from a list of properties
 */
export const getActiveProperties = (properties: Property[]): Property[] => {
  return properties.filter(property => property.status === 'active');
};

/**
 * Get property names by IDs
 */
export const getPropertyNamesByIds = (properties: Property[], propertyIds: string[]): string[] => {
  return propertyIds
    .map(id => properties.find(property => property.id === id)?.name)
    .filter(Boolean) as string[];
};

/**
 * Format date for API requests (YYYY-MM-DD)
 */
export const formatDateForAPI = (date: Date): string => {
  return date.toISOString().split('T')[0];
};

/**
 * Format date range for API requests
 */
export const formatDateRangeForAPI = (dateRange: { startDate: Date; endDate: Date }) => {
  return {
    startDate: formatDateForAPI(dateRange.startDate),
    endDate: formatDateForAPI(dateRange.endDate)
  };
};